<template>
  <header>
    <nav>
      <div class="logo-wrapper">
        <img :src="require('@/assets/images/logo.png')"/>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

header {
  position: fixed;
  top: 0;
  width: 100%;
}

nav {
  min-height: 54px;
  display: flex;
  align-items: center;

  .logo-wrapper {
    margin: 40px auto 0 auto;

    img {
      width: 140px;

      @include mq(md) {
        width: 240px
      }
    }
  }
}
</style>
